import { render, staticRenderFns } from "./AdminLink.vue?vue&type=template&id=50e03596&"
import script from "./AdminLink.vue?vue&type=script&lang=js&"
export * from "./AdminLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports